import type { StoryblokStory, SbContentPage } from '~/cms/storyblok/types/storyblok.d.ts'

export const STORY_KEY = Symbol() as InjectionKey<Ref<StoryblokStory<SbContentPage>>>
export const GRID_SIBLING_COUNT_KEY = Symbol() as InjectionKey<number>
export const COLUMN_SIBLING_INDEX_KEY = Symbol() as InjectionKey<number>
export const IS_IN_FLYOUT_MENU_KEY = Symbol() as InjectionKey<boolean>
